import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { withFirebase } from '../Firebase';
import * as ROUTES from '../../constants/routes';


const PasswordForgetPage = () => {
  const { t } = useTranslation();
  
  return (
    <div>
      <div className='sign-form'>
        <h2>
          {t('passwordForget.title')}
        </h2>
        <PasswordForgetForm />
      </div>
    </div>
  );
};

const INITIAL_STATE = {
  email: '',
  submitting: false,
  error: null,
};

const withTranslation = (Component) => {
  return (props) => {
    const { t } = useTranslation();
    return <Component {...props} t={t} />;
  };
};

class PasswordForgetFormBase extends Component {
  constructor(props) {
    super(props);

    this.state = { ...INITIAL_STATE };
  }

  onSubmit = event => {
    event.preventDefault();
    if (this.state.submitting) return;
    const { email } = this.state;

    this.setState({ submitting: true, error: null });

    this.props.firebase
      .doPasswordReset(email)
      .then(() => {
        this.setState({ ...INITIAL_STATE });
      })
      .catch(error => {
        this.setState({ error });
      })
      .finally(() => {
        this.setState(prevState => (
          prevState.submitting ? { submitting: false } : null
        ));
      });
  };

  onChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  render() {
    const { email, submitting, error } = this.state;
    const { t } = this.props;

    const isInvalid = email === '';

    return (
      <div>
        {error && (
            <p>{error.message}</p>
        )}
        <form onSubmit={this.onSubmit}>
          <fieldset>
            <label>{t('passwordForget.email_label')}</label>
            <input
              name="email"
              value={this.state.email}
              onChange={this.onChange}
              type="text"
              placeholder={t('passwordForget.email_placeholder')}
            />
          </fieldset>
          <button className={'primary' + (submitting ? ' btn-loading' : '')} disabled={isInvalid || submitting} type="submit">
            {t('passwordForget.submit_button')}
          </button>
        </form>
      </div>
    );
  }
}

const PasswordForgetLink = () => {
  const { t } = useTranslation();
  return (
    <Link to={ROUTES.PASSWORD_FORGET}>{t('passwordForget.link_text')}</Link>
  );
};

export default PasswordForgetPage;

const PasswordForgetForm = withTranslation(withFirebase(PasswordForgetFormBase));

export { PasswordForgetForm, PasswordForgetLink };
